// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"406":"32ebb518","764":"0c008780","944":"5bd9fe5b"}[chunkId] + ".chunk.css";
};